module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_003.png
// module id = 2350
// module chunks = 5